// extracted by mini-css-extract-plugin
export default {"promotion":"Promotion__promotion--F_K","button":"Promotion__button--3G1","details":"Promotion__details--hVG","terms":"Promotion__terms--2cO"};